import { List, Monitor, Moon, Sidebar, Sun } from "@phosphor-icons/react/ssr";

const glyphs = { List, Monitor, Moon, Sidebar, Sun };
export function NavigationIcon({ name }: { name: keyof typeof glyphs }) {
  const Glyph = glyphs[name];
  return (
    <Glyph
      size={20}
      weight="regular"
      className="inline-block flex-shrink-0 text-current"
      aria-label={`${name} icon`}
      data-testid={`icon-${name}`}
    />
  );
}
